import { GetScopeSearchRequest, GetScopeValuesRequest, ScopeHierarchyId, ScopeItem, TopologyService } from "../Scopes.types";
import {
    useSubstrateAccountForestTopologyService,
    useSubstrateCafeTopologyService,
    useSubstrateLogicalTopologyService,
    useSubstratePhysicalTopologyService
} from "./Substrate";

import { useDownDetectorTopologyService } from "./useDownDetectorTopologyService";
import { useMaasTopologyService } from "./useMaasTopologyService";

export const useCompositeTopologyService = (): TopologyService => {
    const maasTopologyService = useMaasTopologyService();
    const substrateLogicalTopologyService = useSubstrateLogicalTopologyService();
    const substratePhysicalTopologyService = useSubstratePhysicalTopologyService();
    const substrateAccountForestTopologyService = useSubstrateAccountForestTopologyService();
    const substrateCafeTopologyService = useSubstrateCafeTopologyService();
    const downDetectorTopologyService = useDownDetectorTopologyService();

    const getTopologyService = (scopeHierarchyId: string): TopologyService => {
        let topologyService: TopologyService;
        switch (scopeHierarchyId) {
            case ScopeHierarchyId.SubstrateLogicalScopeHierarchy:
                topologyService = substrateLogicalTopologyService;
                break;
            case ScopeHierarchyId.SubstratePhysicalScopeHierarchy:
                topologyService = substratePhysicalTopologyService;
                break;
            case ScopeHierarchyId.SubstrateAccountForestScopeHierarchy:
                topologyService = substrateAccountForestTopologyService;
                break;
            case ScopeHierarchyId.SubstrateCafeScopeHierarchy:
                topologyService = substrateCafeTopologyService;
                break;
            case ScopeHierarchyId.DownDetectorScopeHierarchy:
                topologyService = downDetectorTopologyService;
                break;
            default:
                topologyService = maasTopologyService;
                break;
        }
        return topologyService;
    };

    return {
        getScopeValueOptions: (request: GetScopeValuesRequest): ScopeItem[] | Promise<ScopeItem[]> => {
            const topologyService = getTopologyService(request.scopeHierarchyId);
            return topologyService.getScopeValueOptions(request);
        },
        getScopeSearch: (request: GetScopeSearchRequest): ScopeItem[] | Promise<ScopeItem[]> => {
            const topologyService = getTopologyService(request.scopeHierarchyId);
            return topologyService.getScopeSearch(request);
        }
    };
};
